// reportComponentRegistry.js
import PipelineHealthHeader from './pipelineHealthHeader';
// import FundedSummaryHeader from './FundedSummaryHeader';

export const reportComponentRegistry = {
    headers: {
        pipelineHealth: PipelineHealthHeader,
        // fundedSummary: FundedSummaryHeader,
    },
};